import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { Button } from "@sw-sw/lib-ui";
import Logo from "../../images/SW-Logo-White.svg";

const SalesRepresentativePage: React.FC = () => {
  return (
    <div className="error-page__wrapper">
      <div className="error-page">
        <header>
          <div className="trial-started__logo-wrapper">
            <img src={Logo} alt='logo' />
          </div>
          <h3>Already a member? <a href={`${process.env.REACT_APP_LOGIN_URL}/login`}>Login</a></h3>
        </header>
        <div className="error-page__body">
          <div className="error-page__inner-box-wrapper">
            <div className="error-page__inner-box" style={{ width: "80%" }}>
              <div className="error-page__check-icon">
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  className='col-danger' size="lg"
                  style={{ width: "100px", height: "100px" }}
                />
              </div>
              <h1>OOPS! 404 Error</h1>
              <h3>We can't seem to find the page you're looking for.</h3>
              <div className="error-page__action-buttons">
                <Button primary onClick={() => window.location.href = "mailto:info@sw2.net"}>
                  Contact Support
                </Button>
                <button onClick={() => window.location.href = "https://sw2.net/"}>
                  Visit Our Website
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesRepresentativePage;
